import type { EndpointDef } from '@skynet/data-helpers';

/**
 * Central endpoint definitions — single source of truth for the Users API.
 *
 * This file drives:
 * - Enhanced API: computed endpoint keys in `enhanceEndpoints`
 * - Hook re-exports: clean name → generated name mapping
 * - MSW mock factories: HTTP method + URL path pattern
 */
export const USERS_API_ENDPOINTS = {
  listUsers: {
    generated: 'usersAdminControllerListUsersV1',
    method: 'get',
    path: '/api/v1/admin/users',
  },
  getUser: {
    generated: 'usersAdminControllerGetUserV1',
    method: 'get',
    path: '/api/v1/admin/users/:id',
  },
  listUserStatuses: {
    generated: 'usersAdminControllerListStatusesV1',
    method: 'get',
    path: '/api/v1/admin/users/status-list',
  },
  updateUser: {
    generated: 'usersAdminControllerUpdateUserV1',
    method: 'put',
    path: '/api/v1/admin/users/:id',
  },
  blockUser: {
    generated: 'usersAdminControllerBlockUserV1',
    method: 'post',
    path: '/api/v1/admin/users/:id/block',
  },
  unblockUser: {
    generated: 'usersAdminControllerUnblockUserV1',
    method: 'post',
    path: '/api/v1/admin/users/:id/unblock',
  },
  resetUserMfa: {
    generated: 'usersAdminControllerResetUserMfaV1',
    method: 'post',
    path: '/api/v1/admin/users/:id/reset-mfa',
  },
  setUserRoles: {
    generated: 'usersAdminControllerSetRolesV1',
    method: 'put',
    path: '/api/v1/admin/users/:id/roles',
  },
  confirmEmail: {
    generated: 'usersAdminControllerConfirmUserEmailV1',
    method: 'post',
    path: '/api/v1/admin/users/:id/confirm-email',
  },

  // we don't use these endpoints in the UI now
  // but we may use them in the future if needed

  // assignUserRole: {
  //   generated: 'usersAdminControllerAssignUserRoleByIdV1',
  //   method: 'post',
  //   path: '/api/v1/admin/users/:id/roles/:roleId',
  // },
  // unassignUserRole: {
  //   generated: 'usersAdminControllerUnassignUserRoleByIdV1',
  //   method: 'delete',
  //   path: '/api/v1/admin/users/:id/roles/:roleId',
  // },
} as const satisfies Record<string, EndpointDef>;

export type UsersEndpointName = keyof typeof USERS_API_ENDPOINTS;
